// extracted by mini-css-extract-plugin
export default {"menu-item":"_2Wrxe","menuItem":"_2Wrxe"};